"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Buoy = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Buoy = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "buoy", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "buoy", fill: "none", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M15.473 19.91v-5.725h12.506l-3.585-3.692L28 6.573H15.494v-1.66a.905.905 0 0 0-.264-.638.936.936 0 0 0-.643-.275h-.548a.935.935 0 0 0-.643.275c-.17.17-.264.4-.264.638V19.91c-2.191.24-4.25 1.15-5.888 2.601A10.336 10.336 0 0 0 4 28h20.626a10.336 10.336 0 0 0-3.244-5.489 10.627 10.627 0 0 0-5.888-2.6", fill: "#909AB5" }) })) })));
};
exports.Buoy = Buoy;
